import React from 'react';
const TipSetter = (props) => {
    return <div>{props?.tip}</div>;
};
export default TipSetter;
